
  export default {
    props: {
      defaultExpanded: { type: Boolean, default: true },
      header: { type: String, default: null },
      label: { type: String, required: true }
    },
    data () {
      return { expanded: false };
    },
    created () {
      this.expanded = this.defaultExpanded;
    },
    methods: {
      expand () {
        if (window.innerWidth >= 1024) {
          this.expanded = !this.expanded;
          return this.expanded;
        }
      }
    }
  };
